<template>
  <div :class="currentTheme" id="newProductsPage">
    <!-- 页面加载动画 -->
    <div class="page-loader" v-if="isLoading">
      <div class="loader-spinner"></div>
    </div>

    <!-- 将滚动功能移到内部容器 -->
    <div class="scroll-container relative" id="scrollContainer" ref="scrollContainer">
      <!-- 面包屑导航 -->
      <div class="breadcrumb-section" v-if="routerName !== '商品首页' && !$route.path.includes('system-center')">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item :to="{ path: '/new-products/home' }">首页</el-breadcrumb-item>
          <el-breadcrumb-item v-if="routerName === '商品详情'" :to="{ path: '/new-products/product-list' }">
            商品列表
          </el-breadcrumb-item>
          <el-breadcrumb-item class="current-page">{{ routerName }}</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div class="pageView">
        <!-- 搜索栏区域 - 修复粘性定位 -->
        <template v-if="routerName !== '商品首页'">
          <Search></Search>
          <!-- <div class="search-section-wrapper">
            <div class="search-section">
              <Search></Search>
            </div>
          </div> -->
        </template>

        <!-- 控制中心区域 -->
        <template v-if="pageHaveControlCenter.includes(routerName)">
          <!-- <div class="control-center-section">
          </div> -->
          <ControlCenter></ControlCenter>
        </template>

        <!-- 主要内容区域 -->
        <div class="main-content-wrapper">
          <div
            class="page-box"
            :class="{ 'full-width': routerName === '商品首页' || routerFullPath.includes('system-center') }"
          >
            <!-- 页面内容区域 -->
            <div
              :class="{
                'page-content': true,
                pt20: routerName !== '商品首页' && !$route.path.includes('system-center')
              }"
            >
              <!-- 单一 router-view + include：进详情不再 v-if 掉列表，面包屑回列表才能还原主从目录 -->
              <keep-alive include="MallGoodsList">
                <router-view></router-view>
              </keep-alive>
            </div>
          </div>
        </div>
      </div>

      <!-- 页脚 -->
      <footer class="page-footer">
        <div class="footer-container">
          <div class="company-info">
            <div class="logo-section">
              <img :src="emblem" alt="公司标志" class="company-logo" />
            </div>
            <div class="company-details">
              <h3 class="company-name">{{ company.storeName }}</h3>
              <div class="contact-info">
                <p class="contact-item">
                  <i class="el-icon-phone"></i>
                  <span>客服热线：{{ company.servicePhone }}</span>
                </p>
                <p class="contact-item">
                  <i class="el-icon-location"></i>
                  <span>地址：{{ company.area + company.address }}</span>
                </p>
              </div>
            </div>
          </div>

          <div class="qr-codes">
            <div class="qr-item">
              <div class="qr-img-container">
                <img :src="offiaccount || siruiOffiaccountIcon" alt="微信公众号" />
              </div>
              <span class="qr-label">公众号</span>
            </div>
            <div class="qr-item">
              <div class="qr-img-container">
                <div ref="mobileQRCode" class="mobile-qr-code" id="mobileQRCode"></div>
              </div>
              <span class="qr-label">手机端</span>
            </div>
            <div class="qr-item">
              <div class="qr-img-container">
                <img :src="miniprogram || smallProgramCodeIcon" alt="小程序" />
              </div>
              <span class="qr-label">小程序</span>
            </div>
          </div>
        </div>

        <!-- 版权信息 -->
        <!-- <div class="copyright">
          <p>© {{ currentYear }} {{ company.name }} 版权所有</p>
        </div> -->
      </footer>
      <div style="height:80px" v-if="pargName.includes(routerName)"></div>
    </div>

    <!-- 返回顶部按钮 -->
    <div
      :class="{ 'back-to-top': true, btm110: pargName.includes(routerName) }"
      v-show="showBackToTop"
      @click="scrollToTop"
    >
      <i class="el-icon-arrow-up"></i>
    </div>
  </div>
</template>

<script>
import Search from "./components/search/Index.vue";
import systemImg from "@/assets/img/newProducts/systemIcon.png";
import officialAccounts from "@/assets/img/newProducts/officialAccounts.png";
import applet from "@/assets/img/newProducts/applet.png";
import phoneCode from "@/assets/img/newProducts/phoneCode.png";
import { getShoppingCartList } from "@/api/shoppingCart";
import ControlCenter from "./controler/ControlCenter.vue";
import QRCode from "qrcodejs2";
import { mapState, mapGetters, mapActions } from "vuex";

export default {
  components: {
    Search,
    ControlCenter
  },
  data() {
    return {
      pargName: ["购物车", "订单详情"],
      systemImg,
      officialAccounts,
      applet,
      phoneCode,
      pageHaveControlCenter: ["商品首页", "商品列表", "商品详情", "购物车", "领券中心"],
      siruiOffiaccountIcon: require("@/assets/img/sirui_offiaccount.png"),
      smallProgramCodeIcon: require("@/assets/img/small-program-code.png"),
      mobileQRCode: null,
      isLoading: false,
      showBackToTop: false,
      currentYear: new Date().getFullYear()
    };
  },
  watch: {
    routerFullPath(newV) {
      if (!newV.includes("/new-products/product-details")) {
        this.scrollToTop();
      }
    }
  },
  computed: {
    routerFullPath() {
      return this.$route.fullPath;
    },
    routerName() {
      return this.$route.name;
    },
    ...mapState("companyInfo", {
      company: state => {
        return state.company;
      },
      emblem: state => {
        return state.emblem;
      },
      offiaccount: state => {
        return state.company.qrCode.offiaccount;
      },
      miniprogram: state => {
        return state.company.qrCode.miniprogram;
      }
    }),
    ...mapState("theme", ["currentTheme"]),
    ...mapGetters("theme", ["colorPalette"])
  },
  methods: {
    ...mapActions("theme", ["updatePrimaryColor", "updateCurrentTheme", "initializeTheme"]),
    initMobileQRCode() {
      const w = 120;
      this.$refs.mobileQRCode.innerHTML = "";
      this.mobileQRCode = new QRCode(this.$refs.mobileQRCode, {
        width: w,
        height: w,
        text: `https://${window.location.hostname}/h5`,
        colorDark: "#333333",
        colorLight: "#ffffff"
      });
      if (this.emblem) {
        setTimeout(() => {
          this.setMobileQRCodeLogoImg();
        }, 200);
      }
    },
    setMobileQRCodeLogoImg() {
      const w = 120;
      const logoImg = new Image();
      logoImg.setAttribute("crossOrigin", "Anonymous");
      logoImg.src = this.emblem;
      logoImg.onload = () => {
        const qrImg = this.mobileQRCode._el.getElementsByTagName("img")[0];
        const canvas = this.mobileQRCode._el.getElementsByTagName("canvas")[0];
        const ctx = canvas.getContext("2d");
        canvas.style.display = "inline-block";

        canvas.style.width = w + "px";
        canvas.style.height = w + "px";

        ctx.drawImage(logoImg, (w - w / 4) / 2, (w - w / 4) / 2, w / 4, w / 4);
        qrImg.src = canvas.toDataURL();
        qrImg.style.display = "none";
      };
    },
    getShoppingCartList() {
      getShoppingCartList({
        keyword: "",
        isNormalBuy: false,
        isPromotion: 0,
        isReducePrice: false
      })
        .then(res => {
          if (res) {
            this.$store.dispatch("user/setShoppingCartNum", res.totalQty || 0);
          }
        })
        .catch(err => {
          if (err.code !== "force-reset-password") {
            this.$message.error(err.message || "购物车加载失败");
          }
        });
    },
    //解决el-tooltip出现双滚动条的问题
    closeTooltip() {
      const list = document.getElementsByClassName("el-tooltip__popper");
      if (list.length > 0) {
        list[list.length - 1].style.display = "none";
      }
    },
    handleScroll() {
      // 监听内部滚动容器的滚动
      const scrollContainer = this.$refs.scrollContainer;
      if (scrollContainer) {
        this.showBackToTop = scrollContainer.scrollTop > 300;
      }
    },
    scrollFuns() {
      this.handleScroll();
      this.closeTooltip();
    },
    scrollToTop() {
      // 滚动内部容器到顶部
      const scrollContainer = this.$refs.scrollContainer;
      if (scrollContainer) {
        scrollContainer.scrollTo({
          top: 0,
          behavior: "smooth"
        });
      }
    }
  },
  mounted() {
    this.initializeTheme();
    this.$bus.$on("shoppingCartRefresh", () => {
      this.getShoppingCartList();
    });
    this.$bus.$on("scrollTop", () => {
      if (!this.$route.path.includes("/new-products/system-center/wl-reconciliation/pay")) {
        this.scrollToTop();
      }
    });
    this.initMobileQRCode();

    // 添加内部滚动容器的滚动监听
    const scrollContainer = this.$refs.scrollContainer;
    if (scrollContainer) {
      scrollContainer.addEventListener("scroll", this.scrollFuns);
    }

    // 确保初始状态正确
    this.handleScroll();
  },
  beforeDestroy() {
    // 移除内部滚动容器的滚动监听
    const scrollContainer = this.$refs.scrollContainer;
    if (scrollContainer) {
      scrollContainer.removeEventListener("scroll", this.scrollFuns);
    }
  }
};
</script>

<style lang="scss">
// @import "@/assets/css/theme.scss";

* {
  padding: 0;
  margin: 0;
  box-sizing: border-box;
}

.w80 {
  width: 80%;
  margin: 0 auto;
}
.lookmore {
  font-size: 14px;
  color: #666;
  cursor: pointer;
  &:hover {
    color: var(--color-primary);
  }
}
.page-width {
  width: calc(100% - 100px);
  max-width: 1700px;
  margin: 0 auto;
}
// 全局滚动条样式
::-webkit-scrollbar {
  width: 6px;
}

::-webkit-scrollbar-track {
  background: #f1f1f1;
}

::-webkit-scrollbar-thumb {
  background: #c1c1c1;
  border-radius: 3px;
}

::-webkit-scrollbar-thumb:hover {
  background: #a8a8a8;
}

/* 修复滚动问题 - 关键修改 */
html,
body {
  height: auto;
  overflow-x: hidden;
}
.tag {
  display: inline-flex;
  align-items: center;
  padding: 4px 8px;
  border-radius: 4px;
  font-family: "PingFang SC", sans-serif;
  font-weight: 400;
  font-size: 12px;
  box-sizing: border-box;
  border-width: 1px;
  border-style: solid;
  box-shadow: none;
  white-space: nowrap;
  flex-shrink: 0; /* 防止标签被压缩 */
  box-sizing: border-box;
  height: 24px;

  .tag-icon {
    margin-right: 4px;
    font-size: 10px;
  }

  &.exchange {
    border-color: rgb(45, 178, 132);
    background-color: rgba(45, 178, 132, 0.1);
    color: rgb(45, 178, 132);
  }

  &.new {
    color: #f58422;
    background-color: rgba(245, 132, 34, 0.101960784313725);
    border-color: rgba(245, 132, 34, 1);
  }

  &.promotion {
    color: #fff;
    background-color: rgb(232, 79, 71);
    border: none;
  }

  &.coupon {
    padding: 0px;
    padding-right: 8px;
    background-color: rgba(232, 79, 71, 0.1);
    color: #f58422;
    border-color: rgba(255, 134, 149, 1);
    .coupon-icon {
      background-color: #f9792e;
      color: #fff;
      padding: 0px 6px;
      display: flex;
      align-items: center;
      height: 100%;
      border-radius: 2px;
      border-top-right-radius: 0;
      border-bottom-right-radius: 0;
      margin-right: 3px;
      font-size: 12px;
    }
  }
}
.price-main {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  margin-bottom: 2px;
}
.price-container {
  display: flex;
  align-items: baseline;

  .price-icon {
    font-size: 14px;
    color: #e84f47;
    font-weight: 600;
  }

  .price-integer {
    font-size: 22px;
    color: #e84f47;
    font-weight: 700;
    margin-left: 2px;
  }

  .price-decimal {
    font-size: 14px;
    color: #e84f47;
    font-weight: 600;
  }

  .price-unit {
    color: #999;
    font-weight: 400;
    font-size: 12px;
    margin-left: 4px;
  }
}
.minBuyQty {
  color: #e84f47;
}
// .price {
//   color: #e84f47;
//   font-size: 22px;
// }
.line-price {
  text-decoration: line-through;
  span {
    font-size: 12px !important;
    color: #999 !important;
  }
}
.line-through {
  text-decoration: line-through;
  color: #999;
}
.price-icon {
  font-size: 14px;
  color: #e84f47;
  font-weight: 600;
}

.price-integer {
  font-size: 22px;
  color: #e84f47;
  font-weight: 700;
  margin-left: 2px;
}

.price-decimal {
  font-size: 14px;
  color: #e84f47;
  font-weight: 600;
}
.price-separator {
  font-size: 18px;
  color: #e84f47;
  font-weight: 600;
}
.price-suffix {
  font-size: 14px;
  color: #e84f47;
  font-weight: 600;
}
.price-unit {
  color: #999;
  font-weight: 400;
  font-size: 12px;
  margin-left: 4px;
}
</style>

<style lang="scss" scoped>
// 保持固定高度
#newProductsPage {
  width: 100%;
  height: calc(100vh - 40px); /* 保持您的固定高度 */
  display: block;
  position: relative;
  background: linear-gradient(135deg, #f5f7fa 0%, #e4e7ec 100%);
  overflow-x: hidden;
}

// 新增内部滚动容器
.scroll-container {
  height: 100%;
  overflow-y: auto;
  overflow-x: hidden;
  background: #efefef;
  /* 修复粘性定位问题 - 确保滚动容器没有设置overflow-x或overflow-y为hidden */
}

// 页面加载动画
.page-loader {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(255, 255, 255, 0.9);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;

  .loader-spinner {
    width: 50px;
    height: 50px;
    border: 4px solid #f3f3f3;
    border-top: 4px solid var(--color-primary);
    border-radius: 50%;
    animation: spin 1s linear infinite;
  }
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

.pageView {
  min-height: calc(100vh - 224px);
  display: block;
  position: relative; /* 修复粘性定位问题 - 确保父级有定位上下文 */

  .control-center-section {
    padding: 0 20px;
    margin-bottom: 20px;
  }
}

/* 修复搜索区域粘性定位 */
.search-section-wrapper {
  position: relative;
  z-index: 100;

  .search-section {
    position: sticky;
    top: 0;
    z-index: 100;
    background: white;
    // padding: 0 20px;
    margin-bottom: 20px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);

    /* 确保Search组件内部有粘性定位的元素 */
    ::v-deep .sticky-element {
      position: sticky;
      top: 0;
      z-index: 101;
    }
  }
}

.main-content-wrapper {
  display: block;
  // padding: 0 20px;
}

.page-box {
  width: calc(100% - 100px);
  min-width: 1064px;
  margin: 0 auto 20px;

  &.full-width {
    width: 100%;
    max-width: none;
  }
}

.breadcrumb-section {
  position: fixed;
  width: calc(100% - 10px);
  background: #efefef;
  top: 135px;
  // left: 50px;
  box-sizing: border-box;
  padding: 10px 50px;
  z-index: 999;

  ::v-deep .el-breadcrumb {
    font-size: 14px;

    .el-breadcrumb__item {
      .el-breadcrumb__inner {
        color: #606266;
        transition: color 0.3s;

        &:hover {
          color: var(--color-primary);
        }
      }

      &:last-child .el-breadcrumb__inner {
        color: var(--color-primary);
        font-weight: 500;
      }
    }

    .el-breadcrumb__separator {
      color: #c0c4cc;
    }
  }
}
.pt20 {
  padding-top: 20px;
}
.page-content {
  // background: #fff;
  border-radius: 8px;
  // box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  min-height: 500px;
}

.page-footer {
  // background: linear-gradient(135deg, #2c3e50 0%, #34495e 100%);
  background: linear-gradient(135deg, var(--color-primary) 0%, var(--color-primary-dark30) 100%);
  color: #fff;
  padding: 40px 20px 20px;
  width: 100%;

  .footer-container {
    max-width: 1200px;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    flex-wrap: wrap;
    gap: 40px;

    @media (max-width: 768px) {
      flex-direction: column;
      align-items: center;
      text-align: center;
    }
  }

  .company-info {
    display: flex;
    align-items: flex-start;
    gap: 20px;

    @media (max-width: 576px) {
      flex-direction: column;
      align-items: center;
    }

    .logo-section {
      flex-shrink: 0;

      .company-logo {
        max-height: 60px;
        max-width: 150px;
        // filter: brightness(0) invert(1);
      }
    }

    .company-details {
      .company-name {
        font-size: 18px;
        margin-bottom: 15px;
        font-weight: 600;
      }

      .contact-info {
        .contact-item {
          display: flex;
          align-items: center;
          margin-bottom: 8px;
          font-size: 14px;
          color: #e0e0e0;

          i {
            margin-right: 8px;
            font-size: 16px;
          }

          @media (max-width: 576px) {
            justify-content: center;
          }
        }
      }
    }
  }

  .qr-codes {
    display: flex;
    gap: 80px;

    @media (max-width: 576px) {
      gap: 20px;
    }

    .qr-item {
      display: flex;
      flex-direction: column;
      align-items: center;

      .qr-img-container {
        width: 136px;
        height: 136px;
        background: #fff;
        border-radius: 8px;
        padding: 8px;
        margin-bottom: 10px;
        box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
        display: flex;
        justify-content: center;
        align-items: center;

        img,
        .mobile-qr-code {
          width: 120px;
          height: 120px;
          object-fit: contain;
        }
      }

      .qr-label {
        font-size: 14px;
        color: #e0e0e0;
      }
    }
  }

  .copyright {
    margin-top: 30px;
    text-align: center;
    padding-top: 20px;
    border-top: 1px solid rgba(255, 255, 255, 0.1);

    p {
      font-size: 12px;
      color: #b0b0b0;
    }
  }
}

// 返回顶部按钮
.back-to-top {
  position: fixed;
  bottom: 30px;
  right: 30px;
  width: 50px;
  height: 50px;
  background: var(--color-primary);
  color: #fff;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.2);
  transition: all 0.3s;
  z-index: 1000;

  &:hover {
    transform: translateY(-3px);
    box-shadow: 0 4px 16px 0 rgba(0, 0, 0, 0.3);
  }

  i {
    font-size: 20px;
  }
}
.btm110 {
  bottom: 110px;
}

// 响应式设计
@media (max-width: 992px) {
  .page-box {
    width: 90%;
  }

  .footer-container {
    gap: 30px;
  }
}

@media (max-width: 768px) {
  .page-box {
    width: 95%;
  }

  .page-footer {
    padding: 30px 15px 15px;
  }

  .back-to-top {
    bottom: 20px;
    right: 20px;
    width: 45px;
    height: 45px;
  }
}

@media (max-width: 576px) {
  .main-content-wrapper {
    padding: 0 10px;
  }

  .page-box {
    width: 100%;
  }

  .breadcrumb-section {
    margin-bottom: 15px;
  }

  .page-content {
    border-radius: 6px;
  }

  .qr-codes {
    justify-content: center;
  }

  /* 移动端修复滚动 */
  .pageView {
    min-height: calc(100vh - 200px);
  }

  /* 移动端修复搜索区域 */
  .search-section-wrapper .search-section {
    padding: 0 10px;
  }
}
</style>
